import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {CommonTransformationService, QueryResult} from '@app/shared';
import { FeedbackPost, FeedbackSubject } from './suggestion-management';

@Injectable()
export class SuggestionManagementDataService {

  constructor (private http: HttpClient, private transform: CommonTransformationService) { }

  getSubjects(feedbackCategory: string): Observable<any> {
    let url = `/suggestion/feedback-subjects/search?feedbackCategory=${feedbackCategory}`;
    return this.http.get<any>(url);
  }

  getPostBySubjectIdAndCategory(subjectId: number, category: string): Observable<QueryResult> {
    let url = `/suggestion/feedback-posts?subjectId=${subjectId}&feedbackCategory=${category}`;
    return this.http.get<QueryResult>(url);
  }

  saveSubject(subject: FeedbackSubject): Observable<any> {
    let url = `/suggestion/feedback-subjects?`;
    return this.http.post<any>(url, subject);
  }

  savePost(post: FeedbackPost): Observable<any> {
    let url = `/suggestion/feedback-posts?`;
    return this.http.post<any>(url, post);
  }

}

